module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "min-height": "200px",
      "height": "500px",
      "margin-top": "-20px"
    }
  }, [_c('div', {
    staticClass: "input-type-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "数据信息"
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.className
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-input', {
    staticClass: "input-form",
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "placeholder": "请输入模板名称",
      "size": "mini"
    },
    model: {
      value: (_vm.templateTitle),
      callback: function($$v) {
        _vm.templateTitle = $$v
      },
      expression: "templateTitle"
    }
  })], 1)]), _vm._v(" "), (_vm.isDevicelistShow == true) ? _c('div', {
    class: _vm.className
  }, [_vm._m(1), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择设备型号",
      "size": "mini"
    },
    on: {
      "change": _vm.changeDeviceType
    },
    model: {
      value: (_vm.order.deviceType),
      callback: function($$v) {
        _vm.$set(_vm.order, "deviceType", $$v)
      },
      expression: "order.deviceType"
    }
  }, _vm._l((_vm.camDeivceList), function(item) {
    return _c('el-option', {
      key: item.value,
      staticClass: "option-item",
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.order.deviceType == '99') ? _c('div', [_c('el-input', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请输入设备型号",
      "size": "mini"
    },
    model: {
      value: (_vm.order.otherDeviceType),
      callback: function($$v) {
        _vm.$set(_vm.order, "otherDeviceType", $$v)
      },
      expression: "order.otherDeviceType"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (['2010120', '2010210', '2010220', '2010320', '2010420', '1010120'].includes(_vm.subCatalogId)) ? _c('div', {
    class: _vm.className
  }, [_vm._m(2), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择设计软件",
      "size": "mini"
    },
    on: {
      "change": _vm.changeSoftware
    },
    model: {
      value: (_vm.designSoftware),
      callback: function($$v) {
        _vm.designSoftware = $$v
      },
      expression: "designSoftware"
    }
  }, _vm._l((_vm.designSoftwareList), function(item) {
    return _c('el-option', {
      key: item.value,
      staticClass: "option-item",
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.order.deviceType == '99') ? _c('div', [_c('el-input', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请输入设备型号",
      "size": "mini"
    },
    model: {
      value: (_vm.order.otherDeviceType),
      callback: function($$v) {
        _vm.$set(_vm.order, "otherDeviceType", $$v)
      },
      expression: "order.otherDeviceType"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (!['1010700', '1010410', '1010510'].includes(_vm.subCatalogId)) ? _c('div', {
    key: _vm.renovate,
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    staticClass: "param-info",
    attrs: {
      "label": "参数信息"
    }
  }), _vm._v(" "), (_vm.deviceParamDetail.polymerization && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-polymerization"
  }, [_vm._m(3), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorPolymerization': _vm.colorPolymerization
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.polymerization),
      "unit": "度",
      "step": Number(1),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('polymerization', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.baseHeight && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-baseHeight"
  }, [_vm._m(4), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorBaseHeight': _vm.colorBaseHeight
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.baseHeight),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('baseHeight', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.shoulderWidth && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-shoulderWidth"
  }, [_vm._m(5), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorShoulderWidth': _vm.colorShoulderWidth
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.shoulderWidth),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('shoulderWidth', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.shoulderAngle && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-shoulderAngle"
  }, [_vm._m(6), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorShoulderAngle': _vm.colorShoulderAngle
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.shoulderAngle),
      "unit": "度",
      "step": Number(1),
      "limit": Number(150)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('shoulderAngle', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.polymerization && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-select-input shoulder",
    staticStyle: {
      "margin-left": "3px",
      "margin-top": "0px"
    }
  }, [_vm._m(7), _vm._v(" "), _c('el-radio', {
    staticClass: "givging",
    attrs: {
      "label": "01"
    },
    model: {
      value: (_vm.order.gingiva),
      callback: function($$v) {
        _vm.$set(_vm.order, "gingiva", $$v)
      },
      expression: "order.gingiva"
    }
  }, [_vm._v("龈下")]), _vm._v(" "), _c('el-radio', {
    staticClass: "givging",
    attrs: {
      "label": "02"
    },
    model: {
      value: (_vm.order.gingiva),
      callback: function($$v) {
        _vm.$set(_vm.order, "gingiva", $$v)
      },
      expression: "order.gingiva"
    }
  }, [_vm._v("齐龈")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "03"
    },
    model: {
      value: (_vm.order.gingiva),
      callback: function($$v) {
        _vm.$set(_vm.order, "gingiva", $$v)
      },
      expression: "order.gingiva"
    }
  }, [_vm._v("龈上")])], 1) : _vm._e(), _vm._v(" "), (['1010210', '1010220'].includes(_vm.subCatalogId) && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap",
    staticStyle: {
      "width": "210px",
      "margin-left": "-100px",
      "margin-top": "-5px"
    }
  }, [(_vm.deviceParamDetail.supragingival && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "el-input-supragingival"
  }, [(_vm.order.gingiva == '01' || _vm.order.gingiva == '03') ? _c('input-num', {
    style: ({
      '--inputColorSupragingival': _vm.colorSupragingival
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.supragingival),
      "step": Number(0.5),
      "limit": Number(3)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('supragingival', $event)
      }
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [((_vm.deviceParamDetail.plateThickness || _vm.plateZero) && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap plate-param el-input-plateThickness"
  }, [_vm._m(8), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorPlateThickness': _vm.colorPlateThickness
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.plateThickness),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('plateThickness', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010698' || _vm.subCatalogId == '1010699') ? _c('div', {
    staticClass: "input-form-wrap params-null-box"
  }) : _vm._e(), _vm._v(" "), ((_vm.deviceParamDetail.teethModelDeviation || _vm.plateZero) && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap plate-param el-input-teethModel"
  }, [_vm._m(9), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorTeethModel': _vm.colorTeethModelDeviation
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.teethModelDeviation),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('teethModelDeviation', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.deviceParamDetail.teethModelDeviation || _vm.plateZero) && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap plate-param el-input-recessedRetention"
  }, [_vm._m(10), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorRecessedRetention': _vm.colorRecessedRetentionAmount
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.recessedRetentionAmount),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('recessedRetentionAmount', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010698' || _vm.subCatalogId == '1010699') ? _c('div', {
    staticClass: "input-form-wrap params-null-box"
  }) : _vm._e(), _vm._v(" "), ((_vm.deviceParamDetail.guideRingCompensatio || _vm.plateZero) && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap plate-param el-input-theGuideRing"
  }, [_vm._m(11), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorTheGuideRing': _vm.colorGuideRingCompensatio
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.guideRingCompensatio),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('guideRingCompensatio', $event)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.deviceParamDetail.adhesiveGap && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-adhesivegap"
  }, [_vm._m(12), _vm._v(" "), _c('input-num', {
    staticStyle: {
      "background-color": "white"
    },
    style: ({
      '--inputColorAdhesiveGap': _vm.colorAdhesiveGap
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.adhesiveGap),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('adhesiveGap', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.adhesiveExtraGap && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-adhesiveExtragap"
  }, [_vm._m(13), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAdhesiveExtraGap': _vm.colorAdhesiveExtraGap
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.adhesiveExtraGap),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('adhesiveExtraGap', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.minThick && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-minthick"
  }, [_vm._m(14), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorMinThick': _vm.colorMinThick
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.minThick),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('minThick', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.wallHeight && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-wallheight"
  }, [_vm._m(15), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorWallHeight': _vm.colorWallHeight
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.wallHeight),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('wallHeight', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.edgeLineDistance && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-edgeLinedistance"
  }, [_vm._m(16), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeLineDistance': _vm.colorEdgeLineDistance
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.edgeLineDistance),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('edgeLineDistance', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.smoothDistance && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-smoothdistance"
  }, [_vm._m(17), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorSmoothDistance': _vm.colorSmoothDistance
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.smoothDistance),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('smoothDistance', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.burRadius && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-burradius"
  }, [_vm._m(18), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorBurRadius': _vm.colorBurRadius
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.burRadius),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('burRadius', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.burGapOffset && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-burgapoffset"
  }, [_vm._m(19), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorBurGapOffset': _vm.colorBurGapOffset
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.burGapOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('burGapOffset', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.edgeLineOffset && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-edgelineoffset"
  }, [_vm._m(20), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeLineOffset': _vm.colorEdgeLineOffset
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.edgeLineOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('edgeLineOffset', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.stretchOffset && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-stretchoffset"
  }, [_vm._m(21), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorStretchOffset': _vm.colorStretchOffset
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.stretchOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('stretchOffset', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.angleOffset && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-angleoffset"
  }, [_vm._m(22), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAngleOffset': _vm.colorAngleOffset
    }),
    attrs: {
      "unit": "度",
      "num": Number(_vm.deviceParamDetail.angleOffset),
      "step": Number(1),
      "limit": Number(90)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('angleOffset', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTonguesideShow && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap",
    staticStyle: {
      "margin": "1px 0 0 -43px",
      "height": "48px"
    }
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "input-radio"
  }, [_c('div', {
    staticClass: "input-radio-box"
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.order.isTongueSide),
      callback: function($$v) {
        _vm.$set(_vm.order, "isTongueSide", $$v)
      },
      expression: "order.isTongueSide"
    }
  }, [_vm._v("无")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.order.isTongueSide),
      callback: function($$v) {
        _vm.$set(_vm.order, "isTongueSide", $$v)
      },
      expression: "order.isTongueSide"
    }
  }, [_vm._v("有")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.order.isTongueSide == '1' && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-select-input"
  }, [_vm._m(24), _vm._v(" "), _c('el-select', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请选择舌侧边补偿参数",
      "size": "mini"
    },
    model: {
      value: (_vm.order.sideOffset),
      callback: function($$v) {
        _vm.$set(_vm.order, "sideOffset", $$v)
      },
      expression: "order.sideOffset"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "舌侧边",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "360度边",
      "value": "1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.tongueSideOffset && _vm.order.isTongueSide == '1' && _vm.order.sideOffset == '0' && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-tonguesideoffset"
  }, [_vm._m(25), _vm._v(" "), _c('input-num', {
    staticStyle: {
      "margin-top": "-5px"
    },
    style: ({
      '--inputColorTongueSideOffset': _vm.colorTongueSideOffset
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.tongueSideOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('tongueSideOffset', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceParamDetail.circleSideOffset && _vm.order.isTongueSide == '1' && _vm.order.sideOffset == '1' && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-circlesideoffset"
  }, [_vm._m(26), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorCircleSideOffset': _vm.colorCircleSideOffset
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.circleSideOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('circleSideOffset', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.deviceParamDetail.occlusalClearance || _vm.deviceParamDetail.occlusalClearance == 0) && ['1010120', '1010310', '1010320', '2010120', '2010320', '2010420'].includes(_vm.subCatalogId) && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-occlusalClearance"
  }, [_vm._m(27), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorOcclusalClearance': _vm.colorOcclusalClearance
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.occlusalClearance),
      "step": Number(0.001),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('occlusalClearance', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.deviceParamDetail.adjacencyGap || _vm.deviceParamDetail.adjacencyGap == 0) && ['1010120', '1010310', '1010320', '2010120', '2010320', '2010420'].includes(_vm.subCatalogId) && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-adjacencyGap"
  }, [_vm._m(28), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAdjacencyGap': _vm.colorAdjacencyGap
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.adjacencyGap),
      "step": Number(0.001),
      "limit": Number(10)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('adjacencyGap', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-inner"
  }, [_vm._m(29), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorInner': _vm.colorInnerCrownThickness
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.innerCrownThickness),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('innerCrownThickness', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-occlusion"
  }, [_vm._m(30), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorOcclusion': _vm.colorOcclusionSpace
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.occlusionSpace),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('occlusionSpace', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-adhesive"
  }, [_vm._m(31), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAdhesive': _vm.colorAdhesiveThickness
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.adhesiveThickness),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('adhesiveThickness', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-edge-horizontal"
  }, [_vm._m(32), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeHorizontal': _vm.colorEdgeHorizontalWidth
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.edgeHorizontalWidth),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('edgeHorizontalWidth', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-edge-tilt"
  }, [_vm._m(33), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeTilt': _vm.colorEdgeTiltWidth
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.edgeTiltWidth),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('edgeTiltWidth', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-edge-inclination"
  }, [_vm._m(34), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeInclination': _vm.colorEdgeInclinationAngle
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.edgeInclinationAngle),
      "step": Number(1),
      "limit": Number(90),
      "unit": "度"
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('edgeInclinationAngle', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-edge-vertical"
  }, [_vm._m(35), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeVertical': _vm.colorEdgeVerticalHeight
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.edgeVerticalHeight),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('edgeVerticalHeight', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-top"
  }, [_vm._m(36), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorTop': _vm.colorTopAdhesiveWidth
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.topAdhesiveWidth),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('topAdhesiveWidth', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-axial"
  }, [_vm._m(37), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAxial': _vm.colorAxialExtraClearance
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.axialExtraClearance),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('axialExtraClearance', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-extra"
  }, [_vm._m(38), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorExtra': _vm.colorRadialExtraClearance
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.radialExtraClearance),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('radialExtraClearance', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-sectional"
  }, [_vm._m(39), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorSectional': _vm.colorCrossSectionalAreaConnector
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.crossSectionalAreaConnector),
      "step": Number(0.005),
      "limit": Number(13),
      "unitSize": '01',
      "unit": "mm²"
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('crossSectionalAreaConnector', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-prohibited"
  }, [_vm._m(40), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorProhibited': _vm.colorProhibitedFillingMargin
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.prohibitedFillingMargin),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('prohibitedFillingMargin', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-gingival"
  }, [_vm._m(41), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorGingival': _vm.colorGingivalThickness
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.gingivalThickness),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('gingivalThickness', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-distance"
  }, [_vm._m(42), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorDistance': _vm.colorDistanceAdjacentTooth
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.distanceAdjacentTooth),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('distanceAdjacentTooth', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-margin-line"
  }, [_vm._m(43), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorMarginLine': _vm.colorMarginLineShift
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.marginLineShift),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('marginLineShift', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-cement"
  }, [_vm._m(44), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorCement': _vm.colorCementGap
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.cementGap),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('cementGap', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-from"
  }, [_vm._m(45), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorFrom': _vm.colorFromMarginLine
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.fromMarginLine),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('fromMarginLine', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-wrap-exo el-input-margin-cement"
  }, [_vm._m(46), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorMarginCement': _vm.colorMarginCementWidth
    }),
    attrs: {
      "num": Number(_vm.deviceParamDetail.marginCementWidth),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('marginCementWidth', $event)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('y-button', {
    staticStyle: {
      "position": "absolute",
      "bottom": "50px",
      "left": "45%"
    },
    attrs: {
      "text": _vm.isEditTemplate == '0' ? '生成模版' : '修改模版',
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.submitForm
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("模板标题")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("CAM制造设备名称")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("设计软件")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("聚合度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("基台不低于")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("肩台宽度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("肩台角度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("肩台与牙龈位置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("导板厚度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("牙齿/模型偏移")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("倒凹保留量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("从导环的补偿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("黏着剂间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("额外黏着剂间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("最小厚度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("壁高度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("到边缘线的距离")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("平滑距离")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("车针半径")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("车针补偿间距")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘线补偿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("延伸补偿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("补偿角度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("舌侧边补偿(宽度)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label",
    staticStyle: {
      "margin": "0px 0 0 9px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("舌侧边补偿参数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("舌侧边")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("360度边")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("咬合间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("邻接间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("内冠厚度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("咬合空间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("粘接剂厚度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘水平宽度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘倾斜宽度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘倾斜角度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘垂直高度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("顶部粘接剂宽度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("轴向额外间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("径向额外间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("连接杆横截面积")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("禁止填除边缘")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("牙龈厚度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("到邻牙距离")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘线下移")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("粘接间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("从边缘线")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘粘接剂宽度")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-531333c3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/paramTemplate.vue
// module id = 631
// module chunks = 0